// Generated types for SysMLType
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLElementReadAPI, SysMLElementWriteAPI } from './sysmlelement';
import { SysMLElementReadAPISchemaObject, SysMLElementWriteAPISchemaObject } from './sysmlelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SysMLTypeReadAPI extends SysMLElementReadAPI {
  /** Whether this type can be instantiated directly (SysML 2.0 concept).

        For Actions:
        - True: High-level, conceptual action that needs to be broken down into sub-actions
          Examples: "Fly", "Navigate", "Process Data", "Communicate"
        - False (default): Concrete action that can be directly implemented
          Examples: "Activate Motor", "Read Sensor", "Send Message"

        Relationship with is_implementation_block:
        - is_abstract focuses on conceptual vs concrete (SysML modeling concern)
        - is_implementation_block focuses on functional vs physical (PDM implementation concern)
        - They are orthogonal: an action can be concrete (is_abstract=False) but still not
          mapped to a physical part (is_implementation_block=False)

        Common patterns:
        - Abstract action: Needs functional breakdown (use AI functional breakdown task)
        - Concrete non-implementation: Can be implemented but may need more breakdown
        - Concrete implementation: Fully defined and mapped to physical parts */
  is_abstract?: boolean;
}

export interface SysMLTypeWriteAPI extends SysMLElementWriteAPI {
  /** Whether this type can be instantiated directly (SysML 2.0 concept).

        For Actions:
        - True: High-level, conceptual action that needs to be broken down into sub-actions
          Examples: "Fly", "Navigate", "Process Data", "Communicate"
        - False (default): Concrete action that can be directly implemented
          Examples: "Activate Motor", "Read Sensor", "Send Message"

        Relationship with is_implementation_block:
        - is_abstract focuses on conceptual vs concrete (SysML modeling concern)
        - is_implementation_block focuses on functional vs physical (PDM implementation concern)
        - They are orthogonal: an action can be concrete (is_abstract=False) but still not
          mapped to a physical part (is_implementation_block=False)

        Common patterns:
        - Abstract action: Needs functional breakdown (use AI functional breakdown task)
        - Concrete non-implementation: Can be implemented but may need more breakdown
        - Concrete implementation: Fully defined and mapped to physical parts */
  is_abstract?: boolean;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SysMLTypeReadAPISchemaObject = SysMLElementReadAPISchemaObject.extend({
  is_abstract: z.boolean().optional(),
}).passthrough();
export const SysMLTypeReadAPISchema: z.ZodType<SysMLTypeReadAPI> = SysMLTypeReadAPISchemaObject;

export const SysMLTypeWriteAPISchemaObject = SysMLElementWriteAPISchemaObject.extend({
  is_abstract: z.boolean().optional(),
}).passthrough();
export const SysMLTypeWriteAPISchema: z.ZodType<SysMLTypeWriteAPI> = SysMLTypeWriteAPISchemaObject;
